// extracted by mini-css-extract-plugin
module.exports = {"btn":"AppRatingModalFormStars_btn__54_s0","star":"AppRatingModalFormStars_star__ejFlZ"};